<div class="page-wrapper">

  @if (loading && !order) {
  <div class="loading-state">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Loading order status...</p>
  </div>
  } @else if (fetchError && !order) {
  <div class="error-card">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <h2>Order Not Found</h2>
    <p>Could not find this order.</p>
  </div>
  } @else if (order) {
  <div class="status-card">

    <div class="order-header">
      <mat-icon class="brand-icon">sports_esports</mat-icon>
      <p class="target">{{ order.target_coins / 1000 | number }}K coins</p>
    </div>

    @if (showLoginWarning) {
    <div class="login-warning" role="alert">
      <mat-icon class="login-warning-icon">warning</mat-icon>
      <div class="login-warning-text">
        <strong>Do NOT log into your account until your order is finished</strong>
        <span>
          Do not sign in from the Web App, the Companion App, or a console/PC. Logging in
          will interrupt the transfer and may cause it to fail. We'll show "Done" here when it's safe to log in again.
        </span>
      </div>
    </div>
    }

    <div class="status-row">
      <mat-chip-set>
        <mat-chip [class]="'status-chip status-' + order.status">
          @if (order.status === 'processing') {
          <mat-spinner diameter="14" class="inline-spinner"></mat-spinner>
          }
          {{ statusLabel }}
        </mat-chip>
      </mat-chip-set>

      @if (order.status === 'failed' && order.error_msg) {
      <span class="error-hint">{{ order.error_msg }}</span>
      }

      <span class="spacer"></span>

      @if (canResume) {
      <button mat-stroked-button color="primary" [disabled]="actionLoading" (click)="doResume()">
        @if (actionLoading) { <mat-spinner diameter="16" class="inline-spinner"></mat-spinner> }
        @else { <mat-icon>play_arrow</mat-icon> }
        Resume
      </button>
      }
      @if (actionError) {
      <span class="error-hint">{{ actionError }}</span>
      }
    </div>

    <div class="progress-section">
      <div class="progress-labels">
        <span>{{ order.transferred_coins / 1000 | number }}K / {{ order.target_coins / 1000 | number }}K coins</span>
        <span class="progress-pct">{{ progressPercentage | number:'1.0-0' }}%</span>
      </div>
      <mat-progress-bar mode="determinate" [value]="progressPercentage"
        [color]="order.status === 'failed' ? 'warn' : order.status === 'completed' ? 'accent' : 'primary'">
      </mat-progress-bar>
    </div>

    @if (order.status === 'completed') {
    <div class="success-banner">
      <mat-icon>check_circle</mat-icon>
      <span>Transfer complete! All {{ order.target_coins / 1000 | number }}K coins transferred.</span>
    </div>
    }

    @if (order.status === 'failed') {
    <div class="creds-section">
      <button mat-stroked-button (click)="showCredsForm = !showCredsForm; correctCredsError = null">
        <mat-icon>key</mat-icon>
        Fix Credentials
      </button>

      @if (showCredsForm) {
      <div class="creds-form">
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput type="password" [(ngModel)]="credsPassword" placeholder="Enter your new password" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Backup Codes</mat-label>
          <input matInput [(ngModel)]="credsBackupCodes" (paste)="onBackupCodesPaste($event)" placeholder="code1, code2, code3, code4, code5, code6" />
          <mat-hint>Comma-separated. Provide a password, backup codes, or both</mat-hint>
        </mat-form-field>
        <button mat-flat-button color="primary" [disabled]="correctCredsLoading" (click)="doCorrectCreds()">
          @if (correctCredsLoading) { <mat-spinner diameter="16" class="inline-spinner"></mat-spinner> }
          Update Credentials
        </button>
        @if (correctCredsError) {
        <div class="error-banner">
          <mat-icon>error_outline</mat-icon>
          <span>{{ correctCredsError }}</span>
        </div>
        }
      </div>
      }
    </div>
    }

    @if (startScreenshotUrl || endScreenshotUrl) {
    <div class="screenshots">
      @if (startScreenshotUrl) {
      <div class="screenshot-item">
        <p class="screenshot-label">Before Transfer</p>
        <img [src]="startScreenshotUrl" alt="Before transfer screenshot" class="screenshot-img" />
      </div>
      }
      @if (endScreenshotUrl) {
      <div class="screenshot-item">
        <p class="screenshot-label">After Transfer</p>
        <img [src]="endScreenshotUrl" alt="After transfer screenshot" class="screenshot-img" />
      </div>
      }
    </div>
    }

    @if (!isTerminal) {
    <p class="polling-hint">
      <mat-icon>autorenew</mat-icon>
      Auto-updating every 5 seconds
    </p>
    }

  </div>
  }

</div>
